/*=========================================================================================
  File Name: moduleSparepart.js
  Description: sparepart Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleBrandState.js";
import mutations from "./moduleBrandMutations.js";
import actions from "./moduleBrandActions.js";
import getters from "./moduleBrandGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
